export default "__VITE_ASSET__HL13j1cg__"